export default __webpack_public_path__ + "static/media/svg-4.04c1420f.svg";